export const withScale = {
  setScale(scale) {
    this._lastScale = this._scale;
    this._scale = scale;
  },
  lastScale() {
    return this._lastScale || 1;
  },
  scale() {
    return this._scale || 1;
  },
  incrementScale() {
    this._scale += 0.1;
  },
  decrementScale() {
    if (this._scale > 0.5) {
      this._scale -= 0.1;
    }
  },
};
